/** Страны ЕС, кроме Польши: для них ставка «nie podl. UE» (NPUE), не обычное «nie podl.». */
const FOREIGN_EU = new Set([
  'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'EL',
  'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE',
]);

const NAME_TO_CODE: Record<string, string> = {
  austria: 'AT', австрия: 'AT',
  belgium: 'BE', belgia: 'BE', бельгия: 'BE',
  bulgaria: 'BG', bułgaria: 'BG', болгария: 'BG',
  croatia: 'HR', chorwacja: 'HR', хорватия: 'HR',
  cyprus: 'CY', cypr: 'CY', кипр: 'CY',
  'czech republic': 'CZ', czechia: 'CZ', czechy: 'CZ', чехия: 'CZ',
  denmark: 'DK', dania: 'DK', дания: 'DK',
  estonia: 'EE', эстония: 'EE',
  finland: 'FI', finlandia: 'FI', финляндия: 'FI',
  france: 'FR', francja: 'FR', франция: 'FR',
  germany: 'DE', niemcy: 'DE', германия: 'DE',
  greece: 'GR', grecja: 'GR', греция: 'GR',
  hungary: 'HU', węgry: 'HU', венгрия: 'HU',
  ireland: 'IE', irlandia: 'IE', ирландия: 'IE',
  italy: 'IT', włochy: 'IT', италия: 'IT',
  latvia: 'LV', łotwa: 'LV', латвия: 'LV',
  lithuania: 'LT', litwa: 'LT', литва: 'LT',
  luxembourg: 'LU', luksemburg: 'LU', люксембург: 'LU',
  malta: 'MT', мальта: 'MT',
  netherlands: 'NL', holandia: 'NL', нидерланды: 'NL',
  poland: 'PL', polska: 'PL', польша: 'PL',
  portugal: 'PT', portugalia: 'PT', португалия: 'PT',
  romania: 'RO', rumunia: 'RO', румыния: 'RO',
  slovakia: 'SK', słowacja: 'SK', словакия: 'SK',
  slovenia: 'SI', słowenia: 'SI', словения: 'SI',
  spain: 'ES', hiszpania: 'ES', испания: 'ES',
  sweden: 'SE', szwecja: 'SE', швеция: 'SE',
};

function toCountryCode(country: string | undefined | null): string | null {
  if (!country) return null;
  const trimmed = country.trim();
  if (!trimmed) return null;
  if (/^[A-Za-z]{2}$/.test(trimmed)) return trimmed.toUpperCase();
  return NAME_TO_CODE[trimmed.toLowerCase()] ?? null;
}

export function isForeignEuCountry(country: string | undefined | null): boolean {
  const code = toCountryCode(country);
  return code != null && FOREIGN_EU.has(code);
}
